(()=>{
  const root=document.querySelector('[data-antar-gift-card]');
  if(!root)return;

  let variants=[];
  try{variants=JSON.parse(root.querySelector('[data-antar-gc-variants]')?.textContent||'[]')}catch(error){}

  const variantInput=root.querySelector('[data-antar-gc-variant-id]');
  const price=root.querySelector('[data-antar-gc-price]');
  const cardValue=root.querySelector('[data-antar-gc-card-value]');
  const addPrice=root.querySelector('[data-antar-gc-add-price]');
  const add=root.querySelector('[data-antar-gc-add]');
  const addLabelText=root.querySelector('[data-antar-gc-add-label-text]');

  const selectVariant=id=>{
    const variant=variants.find(item=>String(item.id)===String(id));
    if(!variant)return;
    if(variantInput)variantInput.value=variant.id;
    if(price)price.textContent=variant.price;
    if(cardValue)cardValue.textContent=variant.price;
    if(addPrice)addPrice.textContent=variant.price;
    if(add)add.disabled=!variant.available;
    if(addLabelText)addLabelText.textContent=variant.available?'Add gift card to bag':'Unavailable';
    if(variant.url&&history.replaceState){
      const url=new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
  };

  root.querySelectorAll('[data-antar-gc-value]').forEach(input=>input.addEventListener('change',()=>selectVariant(input.value)));

  const recipient=root.querySelector('[data-antar-gc-recipient]');
  const flag=root.querySelector('[data-antar-gc-send-flag]');
  const offset=root.querySelector('[data-antar-gc-offset]');
  const email=root.querySelector('[data-antar-gc-recipient-email]');
  const name=root.querySelector('[data-antar-gc-recipient-name]');
  const message=root.querySelector('[data-antar-gc-message]');
  const messageCount=root.querySelector('[data-antar-gc-message-count]');
  const cardRecipient=root.querySelector('[data-antar-gc-card-recipient]');
  const date=root.querySelector('[data-antar-gc-date]');
  const fields=[email,name,message,date];

  if(offset)offset.value=String(new Date().getTimezoneOffset());

  const syncMode=()=>{
    const gift=(root.querySelector('[data-antar-gc-mode]:checked')?.value||'gift')==='gift';
    if(recipient)recipient.hidden=!gift;
    if(flag)flag.disabled=!gift;
    if(offset)offset.disabled=!gift;
    fields.forEach(field=>{if(field)field.disabled=!gift});
    if(email)email.required=gift;
    if(cardRecipient)cardRecipient.textContent=gift?(name?.value.trim()||'For someone you care about'):'For you';
  };

  root.querySelectorAll('[data-antar-gc-mode]').forEach(input=>input.addEventListener('change',syncMode));
  name?.addEventListener('input',syncMode);
  message?.addEventListener('input',()=>{if(messageCount)messageCount.textContent=String(message.value.length)});

  if(date){
    const today=new Date();
    const max=new Date();
    max.setDate(max.getDate()+90);
    const iso=value=>new Date(value.getTime()-value.getTimezoneOffset()*60000).toISOString().slice(0,10);
    date.min=iso(today);
    date.max=iso(max);
  }

  root.querySelectorAll('.antar-gc-faq-list details').forEach(detail=>detail.addEventListener('toggle',()=>{
    if(!detail.open)return;
    root.querySelectorAll('.antar-gc-faq-list details').forEach(other=>{if(other!==detail)other.open=false});
  }));

  syncMode();
  const checked=root.querySelector('[data-antar-gc-value]:checked');
  if(checked)selectVariant(checked.value);

  const surface=root.querySelector('[data-antar-gc-surface]');
  const finePointer=window.matchMedia?.('(hover:hover) and (pointer:fine)').matches;
  const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  if(surface&&finePointer&&!reduced){
    let frame=0;
    let pointer=null;

    const setRest=()=>{
      surface.classList.remove('is-tracking');
      surface.style.setProperty('--gc-rx','1deg');
      surface.style.setProperty('--gc-ry','-3deg');
      surface.style.setProperty('--gc-tx','0px');
      surface.style.setProperty('--gc-ty','0px');
      surface.style.setProperty('--gc-content-x','0px');
      surface.style.setProperty('--gc-content-y','0px');
      surface.style.setProperty('--gc-light-x','72%');
      surface.style.setProperty('--gc-light-y','18%');
      surface.style.setProperty('--gc-shadow-x','0px');
      surface.style.setProperty('--gc-shadow-y','38px');
    };

    const render=()=>{
      frame=0;
      if(!pointer)return;
      const rect=surface.getBoundingClientRect();
      const x=Math.max(0,Math.min(1,(pointer.clientX-rect.left)/rect.width));
      const y=Math.max(0,Math.min(1,(pointer.clientY-rect.top)/rect.height));
      const nx=(x-.5)*2;
      const ny=(y-.5)*2;

      surface.style.setProperty('--gc-rx',`${(-ny*7.2).toFixed(2)}deg`);
      surface.style.setProperty('--gc-ry',`${(nx*9.5).toFixed(2)}deg`);
      surface.style.setProperty('--gc-tx',`${(nx*3.8).toFixed(2)}px`);
      surface.style.setProperty('--gc-ty',`${(ny*2.8).toFixed(2)}px`);
      surface.style.setProperty('--gc-content-x',`${(nx*2.4).toFixed(2)}px`);
      surface.style.setProperty('--gc-content-y',`${(ny*1.8).toFixed(2)}px`);
      surface.style.setProperty('--gc-light-x',`${(x*100).toFixed(1)}%`);
      surface.style.setProperty('--gc-light-y',`${(y*100).toFixed(1)}%`);
      surface.style.setProperty('--gc-shadow-x',`${(-nx*18).toFixed(1)}px`);
      surface.style.setProperty('--gc-shadow-y',`${(38-ny*9).toFixed(1)}px`);
    };

    surface.addEventListener('pointerenter',event=>{
      pointer=event;
      surface.classList.add('is-tracking');
      render();
    });
    surface.addEventListener('pointermove',event=>{
      pointer=event;
      if(!frame)frame=requestAnimationFrame(render);
    });
    surface.addEventListener('pointerleave',()=>{
      pointer=null;
      cancelAnimationFrame(frame);
      frame=0;
      setRest();
    });
    surface.addEventListener('pointercancel',()=>{
      pointer=null;
      cancelAnimationFrame(frame);
      frame=0;
      setRest();
    });
  }
})();
